<template>
  <svg v-bind="attrs" :style="{ fontSize: size ? `${size}px` : 'inherit' }" v-html="html"></svg>
</template>

<script lang="ts">
  import type { SVGAttributes } from 'vue';
  import { icons } from 'feather-icons';

  export function determineIfTappIcon(icon: string): icon is keyof typeof icons {
    return Object.keys(icons).includes(icon);
  }
</script>

<script lang="ts" setup>
  const {
    color = 'currentColor',
    size = undefined,
    icon = 'loader',
  } = defineProps<{
    /**
     * The Color of the icon
     */
    color?: string;

    /**
     * The size of the icon
     */
    size?: number;

    /**
     * The icon name.
     * You can look up the available icons here or in the Icon type abve: https://feathericons.com/
     */
    icon: keyof typeof icons;
  }>();

  const html = computed(() => icons[icon]?.contents);

  const attrs = computed(() => ({
    ...useAttrs(),
    ...((icons[icon]?.attrs as SVGAttributes) ?? {}),
    ...{ width: size ?? 24, height: size ?? 24 },
    ...(color && { stroke: color }),
  }));
</script>

<style lang="postcss" scoped>
  svg {
    display: inline-block;
    width: 1em;
    height: 1em;
  }
</style>
